import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface PartnerInfo {
  name?: string;
  phone?: string;
  email?: string;
  partnerId?: string;
  numClients: number;
  pendingTotal: number;
  totalBilling: number;
}

@Component({
  selector: 'app-btb-partner-info',
  templateUrl: './btb-partner-info.component.html',
  styleUrls: ['./btb-partner-info.component.scss']
})
export class BtbPartnerInfoComponent {
  @Input() partnerInfo!: PartnerInfo;
  @Input() showEmail: boolean = false;
  @Input() showCopyButton: boolean = true;
  @Output() copyRegistrationLink = new EventEmitter<void>();

  constructor(
    private translate: TranslateService,
    private snackBar: MatSnackBar
  ) {}

  onCopyRegistrationLink() {
    if (this.partnerInfo.partnerId) {
      const registrationLink = `${window.location.origin}/onboarding/register?code=${this.partnerInfo.partnerId}`;
      
      navigator.clipboard.writeText(registrationLink).then(() => {
        this.snackBar.open(
          this.translate.instant('BTB.DASHBOARD.REGISTRATION_LINK_COPIED'),
          'Cerrar',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['success-snackbar']
          }
        );
      }).catch(() => {
        this.snackBar.open(
          this.translate.instant('BTB.DASHBOARD.ERROR_COPYING_LINK'),
          'Cerrar',
          {
            duration: 3000,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['error-snackbar']
          }
        );
      });
    }
  }


  getFullName(): string {
    return this.partnerInfo.name || this.partnerInfo.phone || this.translate.instant('BTB.DASHBOARD.USER_NOT_LOADED');
  }
}
